import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import ExcellenceSection from './components/ExcellenceSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main className="min-h-screen">
      <HeroSection />
      <PhilosophySection />
      <ExcellenceSection />
      <ContactSection />
    </main>
  );
}